import { render, staticRenderFns } from "./DocumentsList1.vue?vue&type=template&id=640bf004&scoped=true&"
import script from "./DocumentsList1.vue?vue&type=script&lang=js&"
export * from "./DocumentsList1.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsList1.vue?vue&type=style&index=0&id=640bf004&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640bf004",
  null
  
)

export default component.exports